import type React from 'react';
import { useCallback } from 'react';

import { PlaybookCard } from '../../playbook-card/playbook-card';

import { usePlaybooks } from '../use-playbooks';
import { useOpenRuleEditor } from '../use-open-rule-editor';
import { messages } from '../messages';

export const CommercialRuleCard: React.FC = () => {
  const openRuleEditor = useOpenRuleEditor();
  const { commercialRule } = usePlaybooks();
  const handleClick = useCallback(() => openRuleEditor(commercialRule), [openRuleEditor, commercialRule]);

  return (
    <PlaybookCard
      description={messages.commercialShippingDescription}
      glyph='warehouse'
      onClick={handleClick}
      title={messages.commercialShippingTitle}
    />
  );
};
